import type { SVGProps } from 'react';

const IconCloseOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.2039 3.80274C11.9439 3.54274 11.5239 3.54274 11.2639 3.80274L8.00389 7.05607L4.74389 3.79607C4.48389 3.53607 4.06389 3.53607 3.80389 3.79607C3.54389 4.05607 3.54389 4.47607 3.80389 4.73607L7.06389 7.99607L3.80389 11.2561C3.54389 11.5161 3.54389 11.9361 3.80389 12.1961C4.06389 12.4561 4.48389 12.4561 4.74389 12.1961L8.00389 8.93607L11.2639 12.1961C11.5239 12.4561 11.9439 12.4561 12.2039 12.1961C12.4639 11.9361 12.4639 11.5161 12.2039 11.2561L8.94389 7.99607L12.2039 4.73607C12.4572 4.48274 12.4572 4.05607 12.2039 3.80274Z" />
  </svg>
);

export default IconCloseOutline;
